import { Component, OnInit } from '@angular/core';
import { ClassModel, ClassService } from '../models';
import { MatDialog } from '@angular/material/dialog';
import { ClassDialogComponent } from '../class-dialog/class-dialog.component';
import { plainToClass } from 'class-transformer';
import { MatTableDataSource } from '@angular/material/table';
import { rowAnimation, detailExpand } from '../app.animations';
import { DeleteDialogComponent } from '../delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-class-list-page',
  templateUrl: './class-list-page.component.html',
  styleUrls: ['./class-list-page.component.scss'],
  animations: [
    detailExpand(),
    rowAnimation()
  ],
})
export class ClassListPageComponent implements OnInit {

  displayedColumns = ['title', 'description', 'deprecationPeriod', 'delete'];
  dataSource = new MatTableDataSource<ClassModel>();
  expandedElement: any | null;

  constructor(private service: ClassService, public dialog: MatDialog) {
    this.service.list().subscribe(
      (data) => {
        this.dataSource.data = data;
      },
      (error) => {},
      () => {}
    )
  }

  ngOnInit(): void {
  }

  add() {
    this.openDialog();
  }

  delete(data: ClassModel) {
    if(!data._id) return;

    const deleteDialogRef = this.dialog.open(DeleteDialogComponent, {
      data: { name: data.title }
    });

    deleteDialogRef.afterClosed().subscribe(result => {
      if(result === undefined || result === null) return;
      if(result) {
        this.service.delete(data._id).subscribe({
          next: () => {
            const dataList = this.dataSource.data;
            const index = dataList.findIndex((element) => {
              return element._id && element._id === data._id;
            });
            if(!index) return;
            dataList.splice(index, 1);
            this.dataSource.data = dataList;
          },
          error: () => {},
          complete: () => {}
        });
      }
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ClassDialogComponent, {
      // width: '300px',
      // height: '500px',
      data: new ClassModel()
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result === undefined || result === null) return;
      console.log('The dialog was closed');
      this.service.create(result).subscribe(
        (data) => {
          const dataList = this.dataSource.data;
          dataList.push(plainToClass(ClassModel, data));
          this.dataSource.data = dataList;
         },
        (error) => {},
        () => {}
      )
    });
  }

  openClass(data: ClassModel) {
    const dialogRef = this.dialog.open(ClassDialogComponent, {
      data
    });
    dialogRef.afterClosed().subscribe();
  }

}
